import { useSuspenseQuery } from '@tanstack/react-query';

import { accountLayoutQueryOptions } from '@lib/query/options/account';
import AddressBook from '@modules/account/components/address-book';

/**
 * Account Addresses Page
 *
 * Displays customer shipping addresses with add/edit/delete functionality.
 */
export default function AccountAddressesPage() {
  const { data } = useSuspenseQuery(accountLayoutQueryOptions());

  if (!data.customer) {
    return null;
  }

  // Use customer addresses directly - types are now consistent
  const addresses = data.customer.addresses ?? [];

  return (
    <div className="w-full" data-testid="addresses-page-wrapper">
      <AddressBook addresses={addresses} />
    </div>
  );
}
